import styled from "styled-components";
import { mediaQueries } from "../../../styles/mediaQueries";
import { Link } from "react-router-dom";

export const LowerHeaderStyled = styled.div`
  background-color: var(--secondary);
  padding: 16px 0;

  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;  /* Лого — инпут — меню */
  }
`;

export const HeadLogoLinkStyled = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 24px;
  font-weight: bold;
  color: var(--textSecondary);

  ${mediaQueries("mobile")`
    font-size: 18px;
  `}

  svg {
    width: 32px;
    height: 32px;
  }
`;

export const SearchWrapper = styled.div`
  position: relative;
  flex: 0 1 500px;      /* растёт до 500px */
  max-width: 100%;

  ${mediaQueries("tablet")`
    flex: 0 1 300px;
  `}
`;

export const SearchInputStyled = styled.input`
  width: 100%;
  padding: 0.5rem 1rem;
  border-radius: 24px;
  border: 1px solid #ccc;
  font-size: 1rem;
  transition: border-color 0.2s;
  outline: none;

  &:focus {
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(255,107,8,0.2);
  }
`;

export const MenuWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  ${mediaQueries("mobile")`
    gap: 12px;
  `}
`;
